// extracted by mini-css-extract-plugin
var _1 = "InputClearButton-moduleInputClearButton__npRoi";
export { _1 as "InputClearButton" }
